import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): string {
    const value = params.translateService.instant(params.key);

    if (!value || value === '') {
      console.warn(`[i18n] Missing or empty translation for key: "${params.key}"`);
      return params.key;
    }
    return value;
  }
}
